export default __webpack_public_path__ + "static/media/takeNAEPnow_homePage_hero.229b828c.png";